const validationMessages = {
	password: "Must be at least 8 characters long",
	email: "Must be a valid email address",
	otp: "Must be exactly 6 characters long",
	name: "Must be atleast 2 characters long"
}

export default validationMessages;